// extracted by mini-css-extract-plugin
module.exports =  {"filter":"UOS20IJVQjqdSbgVcs4u"};